import React from "react";
import '../../../assets/scss/croppie.scss';
import OutsideClickHandler from "react-outside-click-handler";
import {
    CameraIconHoc,
    ClosePopupHoc,
    EditCameraHoc,
    loaderGIF,
    RemoveHoc,
    ResetHoc,
    SampleProfile,
    TakephotoHoc,
    TickHoc,
    UploadHoc,
    ViewphotoHoc,
    // ViewphotoHoc,
} from "../../../assets/images";
import "../../../assets/scss/minEmoji.scss";
import {
    CAMERA_ERROR,
    CAMERA_NOT_FOUND,
    CAMERA_PERMISSION_DENIED,
    CANCEL,
    CROP_PHOTO,
    PERMISSION_DENIED,
    PROFILE,
    REMOVE,
    REMOVE_PHOTO,
    REMOVE_YOUR_PROFILE_PHOTO,
    TAKE_PHOTO,
    UPLOAD_PHOTO,
    VIEW_PHOTO,
    // VIEW_PHOTO,
} from "../../../processENV";
import WebChatFields from "./WebChatFields.js";
import ProfileImage from "../../Common/ProfileImage";
import { useSelector } from "react-redux";
import CustomIcon from "../../../assets/images/CustomIcon";
import WebChatCroppie from "../CroppieImage/WebChatCroppie";
import { WebChatCropOption } from "../CroppieImage/WebChatCropOption";
import Cropme from 'croppie';
import { blockOfflineAction, dataURLtoFile, fileToBlob, isAppOnline } from "../../../Helpers/Utility";
import {toast} from 'react-toastify';
import { NO_INTERNET, PROFILE_UPDATE_SUCCESS } from "../../../Helpers/Constants";
import SDK from "../../../SDK";
import IndexedDb from "../../../Helpers/IndexedDb";
import WebChatCamera from "./WebChatCamera";


const WebChatVCard = (props = {}) => {
    const store = useSelector(state => state)
    const {dynamicIcon:{data}} = store
    const { data:vCardData } = store.vCardData
    const {
        mf_EditCamera
    }=data
    let cropme;
    const localDb = React.useMemo(() => new IndexedDb(), []);
    const [webChatVCardState, setWebChatVCardState] = React.useState({
        viewProfileStatus: false,
        profileImg: "",
        showImgDropDown: false,
        showProfileImg: false,
        profileCamera: false,
        showProfileCamera: false,
        photoTaken: false,
        camImage: "",
        camImageFile: "",
        cameraLoader: false,
        onCameraError: false,
        onCameraPermissionDenied: false,
        filename: "image",
        loaderIcon: false,
        cameraPopup: false,
        openCropy: false,
        showProfilePhotoRemove : false,
        cc:'',
    });
    const {
        viewProfileStatus,
        profileImg,
        showImgDropDown,
        showProfileImg,
        showProfileCamera,
        photoTaken,
        onCameraError,
        onCameraPermissionDenied,
        loaderIcon,
        cameraPopup,
        openCropy,
        showProfilePhotoRemove,
        camImage,
        camImageFile,
        filename,
    } = webChatVCardState;
    const [cropState,setCropState] = React.useState('')
    const handleViewProfile = () => {
        setWebChatVCardState({
            ...webChatVCardState,
            viewProfileStatus:true
        });
        props.handleBack();
    }
    const handleVCardClose = () => {
        setWebChatVCardState({
            ...webChatVCardState,
            viewProfileStatus:false
        });
    }
    const handleProfileImgDropDownVcard = (e) => {
        setWebChatVCardState({
            ...webChatVCardState,
            showImgDropDown: !showImgDropDown, openCropy: true
        })
    }

    /**
     * handleProfileImageShow() method to maintain state to show profile image in big screen.
     */
    const handleProfileImageShow = (e) => {
        setWebChatVCardState({
            ...webChatVCardState, showProfileImg: true, showImgDropDown: false, openCropy: false });
    }

    /**
     * setWebcamImageVcard() method to maintain state to set a image taken from webcamera.
     */
    const setWebcamImageVcard = (webcamImageVcard = {}) => {
        if (webcamImageVcard.size > 0) {
            let file = new FileReader();
            file.readAsDataURL(webcamImageVcard);
            file.onload = () => {
                // // let fileImage = file.result;
                setWebChatVCardState({
                    ...webChatVCardState,
                    photoTaken: true, camImageFile: webcamImageVcard, 
                    camImage: webcamImageVcard,openCropy: true
                })
                // updateProfileImage(webcamImageVcard)
            }
        } else {
            setWebChatVCardState({
                ...webChatVCardState, showProfileCamera: true })
        }
    }

    /**
     * onCameraCheckVcard() method to find whether camera device is there.
     */
    const onCameraCheckVcard = (errorVacrd = {}) => {
        if (errorVacrd.name === "NotAllowedError") {
            setWebChatVCardState({
                ...webChatVCardState,onCameraPermissionDenied: true });
        } else if (errorVacrd.name === "NotFoundError") {
            setWebChatVCardState({
                ...webChatVCardState, onCameraError: true })
        }
    }

    /**
     * handleProfileCameraShow() method to open camera popup.
     */
    const handleProfileCameraShow = (e, processType) => {
        // // if (processType !== 'reset' && blockOfflineAction()) return;
        setWebChatVCardState({
            ...webChatVCardState, showProfileCamera: true, showImgDropDown: false, openCropy: false, photoTaken: false, cameraLoader: true });
    }
    /**
     * handleProfilePhotoRemoveShow() method to open profile photo remove prompt.
     */
    const handleProfilePhotoRemoveShow = (e) => {
        // // if (blockOfflineAction()) return;
        setWebChatVCardState({
            ...webChatVCardState, showProfilePhotoRemove: true, showImgDropDown: false, openCropy: false });
    }

    /**
     * handleProfileRemovephotoClose() method to close profile photo remove prompt.
     */
    const handleProfileRemovephotoClose = (e) => {
        setWebChatVCardState({
            ...webChatVCardState, showProfilePhotoRemove: false });
    }

    /**
     * removeProfileImage() method to maintain state to profile picture.
     */
    const removeProfileImage = async (e) => {
        // // if (blockOfflineAction()) return;
        // // let { vCardData } = this.state;
        let response = await SDK.setUserProfile(vCardData.nickName, "", vCardData.status, vCardData.mobileNumber, vCardData.email);
        if (response.statusCode === 200) {
            setWebChatVCardState({
                ...webChatVCardState,
                showImgDropDown: false,
                openCropy: false,
                showProfilePhotoRemove: false
            });
            toast.success('Profile picture removed successfully');
        } else {
            toast.error(response.message);
        }
    }
    /**
     * handleProfileCameraClose() method to close profile camera popup.
     */
    const handleProfileCameraClose = (e) => {
        handleProfileCameraPopupClose();
    }

    /**
     * handleProfileImgClose() method to maintain state to close profile image.
     */
    const handleProfileImgClose = (e) => {
        setWebChatVCardState({
            ...webChatVCardState, showProfileImg: false });
    }
    const handleCropImage = () => {
        if (!isAppOnline()) {
            blockOfflineAction()
            return
        }
        cropImage();
    }
    // // const handleProfileRemovephotoClose = () => {}
    // // const removeProfileImage = () => {}

    /**
     * handleProfileCameraPopupClose() method to close profile camera popup.
     */
    const handleProfileCameraPopupClose = () => {
        setWebChatVCardState({
            ...webChatVCardState,
            showProfileCamera: false,
            photoTaken: false,
            onCameraError: false,
            onCameraPermissionDenied: false,
            loaderIcon: false,
            cameraPopup: false,
            showImgDropDown: false,
            openCropy: false
        });
    }

    const closeDropDown = () => {
        setWebChatVCardState({
            ...webChatVCardState,
            showImgDropDown: false
        });
    };

    React.useEffect(()=>{
        if(cameraPopup === true) addFromFile(camImage);
    },[cameraPopup])
    
    React.useEffect(()=>{
        if(photoTaken === true) addFromCamera(camImageFile);
    },[photoTaken])

    React.useEffect(()=>{
		if(vCardData) {
			setWebChatVCardState({
				...webChatVCardState,
                vCardDatas: vCardData
            });
            if(openCropy === false) handleProfileImg(vCardData);
		}
	},[vCardData,openCropy])
    
	React.useEffect(()=>{
		if(vCardData) {
			setWebChatVCardState({
				...webChatVCardState,
                vCardDatas: vCardData
            });
			handleProfileImg(vCardData);
		}
	},[])

    /**
	* handleProfileImg() method to perform fetch the image form url and encrypt the vcard data.
	*
	* @param {object} response
	*/
	const handleProfileImg=(response) => {
		// // let token = getFromLocalStorageAndDecrypt('token');
		let token = "";
		if (response.image || token) {
			localDb.getImageByKey(response.image, 'profileimages').then(blob => {
				// // const URL = window.URL || window.webkitURL;
				const blobUrl = window.URL.createObjectURL(blob);
				setWebChatVCardState({
					...webChatVCardState, profileImg: blobUrl });
			}).catch(err => {
				setWebChatVCardState({
					...webChatVCardState, profileImg: SampleProfile });
			})
		} else {
			setWebChatVCardState({
				...webChatVCardState, profileImg: SampleProfile, showProfileImg: false });
		}
	}

    /**
     * updateProfileImage() to get image file from child component.
     */
    const updateProfileImage = (file) => {
        if (cropme) {
            cropme.destroy();
        }
        if (file) {
            setWebChatVCardState({
                ...webChatVCardState,
                filename: file.name,
                camImage: file,
                cameraPopup: true
            })
        }
    }

    const addFromFile = (file) => {
        const element = document.getElementById("fileContainer")
        cropme = new Cropme(element, WebChatCropOption);
        let reader = new FileReader();
        reader.onload = function (e) {
            cropme.bind({
                url: e.target.result
            }).then(() => {
                Object.assign(document.querySelector('.cr-viewport').style, {
                    width
                        : '200px', height: '200px'
                })
                cropme.setZoom(0)

            })
        };
        reader.readAsDataURL(file);
        setCropState(cropme);
    }

    const addFromCamera = (file) => {
        const element = document.getElementById("CameraContainer")
        cropme = new Cropme(element, WebChatCropOption);
        let reader = new FileReader();
        reader.onload = function (e) {
            cropme.bind({
                url: e.target.result
            }).then(() => {
                Object.assign(document.querySelector('.cr-viewport').style, {
                    width
                        : '200px', height: '200px'
                })
                cropme.setZoom(0)
            })
        };
        reader.readAsDataURL(file);
        setCropState(cropme);
    }

    /**
     * cropImage() to crop the selected image.
     */
    const cropImage = () => {
        cropState.result({
            type: "base64",
            size: "original"
        }).then(base64 => {
            const imageFile = dataURLtoFile(base64, filename);
            setWebChatVCardState({
                ...webChatVCardState,
                loaderIcon: true
            }) 
        handleSaveImage(imageFile)
        })        
    }

    /**
     * handleSaveImage() to save the selected image.
     */
    const handleSaveImage = async (image) => {
        try {
            // // let vCardDatas = vCardData;
            const response = await SDK.setUserProfile(vCardData.nickName, image, vCardData.status, vCardData.mobileNumber, vCardData.email)
            if (response.statusCode !== 200) {
                // let message = response.message;
                // To get the internet offline status,
                // execute the toastr in setTimeout
                setTimeout(() => {
                    if (!navigator.onLine) {
                    let message = NO_INTERNET;
                    message && toast.error(message);
                    }
                }, 150);
            }

            if (response.statusCode === 200) {
                const fileBlob = await fileToBlob(image);
                setWebChatVCardState({
                    ...webChatVCardState,
                     profileImg: URL.createObjectURL(fileBlob) 
                })
                toast.success(PROFILE_UPDATE_SUCCESS)
                // // indexedDb.setImage(response.fileToken, fileBlob, "profileimages");
                // // toastr.success(PROFILE_UPDATE_SUCCESS);
            }

            handleProfileCameraPopupClose();
        } catch (error) {
            toast.error(error.message);
            handleProfileCameraPopupClose();
        }
    }

    /**
     * webChat page renderBased on condition
    */
   /**
    const WebChatCroppieLoad = (loaderIcons = false, cameraPopUp = false) => {
            <WebChatCroppie
                type={PROFILE}
                loader={loaderIcons}
                cameraPopup={cameraPopUp}
                cropImage={cropImage}
                closeDropDown={closeDropDown}
                updateProfileImage={updateProfileImage}
                closePopUp={handleProfileCameraPopupClose}
            />
        return
    };
    */
    return (
        <React.Fragment>
            <div className="profile-img-name" onClick={() => handleViewProfile()}>
                <div className="image">
                    <ProfileImage
                        chatType={'chat'}
                        imageToken={vCardData?.thumbImage !== "" ? vCardData?.thumbImage : vCardData?.image}
                        temporary={true}
                        name={vCardData?.nickName}
                    />
                </div>
                <span title={vCardData?.nickName === "" ? vCardData?.userId : vCardData?.nickName}>
                    {vCardData?.nickName === "" ? vCardData?.userId : vCardData?.nickName}
                </span>
            </div>
            {viewProfileStatus && (
                <div className="userprofile">
                    <OutsideClickHandler
                        onOutsideClick={() => {
                            setWebChatVCardState({
                                ...webChatVCardState,
                                viewProfileStatus: false,
                            });
                        }}
                    >
                        <div className="userprofile-popup">
                            <div className="userprofile-header">
                                <i onClick={() => handleVCardClose()}>
                                    <ClosePopupHoc  viewBox="0 0 24 24" />
                                </i>
                                <h5>{"Profile"}</h5>
                            </div>
                            <div className="userprofile-body">
                                <div className="userprofile-image">
                                    <OutsideClickHandler
                                        onOutsideClick={() => {
                                            setWebChatVCardState({
                                                ...webChatVCardState,
                                                showImgDropDown: false,
                                                openCropy: false,
                                            });
                                        }}
                                    >
                                        {/* user image empty no perview button */}
                                        <ProfileImage
                                            chatType={'chat'}
                                            imageToken={vCardData?.thumbImage !== "" ? vCardData?.thumbImage : vCardData?.image}
                                            temporary={true}
                                            name={vCardData?.nickName}
                                            profileImageView={(e) => profileImg !== SampleProfile ? handleProfileImageShow(e) : null}
                                        />
                                        <i
                                            className="camera-edit"
                                            onClick={(e) => handleProfileImgDropDownVcard(e)}
                                        >
                                        <CustomIcon
                                            icon={mf_EditCamera ? mf_EditCamera : <EditCameraHoc viewBox="0 0 35.141 35.188" />}
                                            {...props}
                                        />
                                        </i>
                                        {showImgDropDown && (
                                            <React.Fragment>
                                                <ul className="profile-dropdown">
                                                    {profileImg && (
                                                        <>
                                                            {vCardData?.image !== "" && (
                                                                <li
                                                                    title={VIEW_PHOTO}
                                                                    onClick={(e) => handleProfileImageShow(e)}
                                                                >
                                                                    <i className="profileedit-options">
                                                                        <ViewphotoHoc />
                                                                    </i>
                                                                    <span>{VIEW_PHOTO}</span>
                                                                </li>
                                                            )}
                                                            <li
                                                                title={TAKE_PHOTO}
                                                                onClick={(e) => handleProfileCameraShow(e)}
                                                            >
                                                                <i className="profileedit-options">
                                                                    <TakephotoHoc viewBox="0 0 14.8 12.8" />
                                                                </i>
                                                                <span>{TAKE_PHOTO}</span>
                                                            </li>
                                                            {vCardData?.image !== "" && (
                                                                <li
                                                                    title={REMOVE_PHOTO}
                                                                    onClick={(e) =>
                                                                        handleProfilePhotoRemoveShow(e)
                                                                    }
                                                                >
                                                                    <i className="profileedit-options">
                                                                        <RemoveHoc viewBox="0 0 14 14" />
                                                                    </i>
                                                                    <span>{REMOVE_PHOTO}</span>
                                                                </li>
                                                            )}
                                                            <li className="upload_photo" title={UPLOAD_PHOTO}>
                                                                <label
                                                                    className="UploadLabel"
                                                                    htmlFor="ProfileUpload"
                                                                ></label>
                                                                <i className="profileedit-options">
                                                                    <UploadHoc viewBox="0 0 14 14"/>
                                                                </i>
                                                                <span className="uploadphoto">
                                                                    <span>{UPLOAD_PHOTO}</span>
                                                                </span>
                                                            </li>
                                                        </>
                                                    )}

                                                    {!profileImg && (
                                                        <>
                                                            <li
                                                                title={TAKE_PHOTO}
                                                                onClick={(e) => handleProfileCameraShow(e)}
                                                            >
                                                                <i className="profileedit-options">
                                                                    <TakephotoHoc viewBox="0 0 14.8 12.8" />
                                                                </i>
                                                                <span>{TAKE_PHOTO}</span>
                                                            </li>
                                                            <li title={UPLOAD_PHOTO}>
                                                                <label
                                                                    className="UploadLabel"
                                                                    htmlFor="ProfileUpload"
                                                                ></label>
                                                                <i className="profileedit-options">
                                                                    <UploadHoc viewBox="0 0 14 14"/>
                                                                </i>
                                                                <span className="uploadphoto">
                                                                    <span>{UPLOAD_PHOTO}</span>
                                                                </span>
                                                            </li>
                                                        </>
                                                    )}
                                                </ul>
                                            </React.Fragment>
                                        )}
                                        <React.Fragment>
                                            {openCropy && (
                                                // <>{WebChatCroppieLoad(loaderIcon, cameraPopup)}</>
                                                <><WebChatCroppie
                                                type={PROFILE}
                                                loader={loaderIcon}
                                                cameraPopup={cameraPopup}
                                                cropImage={cropImage}
                                                closeDropDown={closeDropDown}
                                                updateProfileImage={updateProfileImage}
                                                closePopUp={handleProfileCameraPopupClose}
                                            /></>
                                            )}
                                        </React.Fragment>
                                        {showProfileImg && (
                                            <div className="Viewphoto-container">
                                                <div className="Viewphoto-preview">
                                                    <img src={profileImg} alt="vcard-profile" />
                                                    <i
                                                        className="preview-close"
                                                        onClick={(e) => handleProfileImgClose(e)}
                                                    >
                                                        <ClosePopupHoc  viewBox="0 0 24 24" />
                                                    </i>
                                                </div>
                                            </div>
                                        )}
                                        {showProfileCamera && (
                                            <div className="camera-container">
                                                {onCameraError && (
                                                    <div className="camera-popup">
                                                        <h4>{CAMERA_NOT_FOUND}</h4>
                                                        <i>
                                                            <CameraIconHoc viewBox="0 0 79 52.5" />
                                                        </i>
                                                        <p>{CAMERA_ERROR}</p>
                                                        <div className="popup-controls">
                                                            <button
                                                                type="button"
                                                                className="btn-okay"
                                                                onClick={(e) => handleProfileCameraClose(e)}
                                                                name="btn-cancel"
                                                            >
                                                                {"Okay"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {onCameraPermissionDenied && (
                                                    <div className="camera-popup">
                                                        <h4>{PERMISSION_DENIED}</h4>
                                                        <i>
                                                            <CameraIconHoc viewBox="0 0 79 52.5" />
                                                        </i>
                                                        <p>{CAMERA_PERMISSION_DENIED}</p>
                                                        <div className="popup-controls">
                                                            <button
                                                                type="button"
                                                                className="btn-okay"
                                                                onClick={(e) => handleProfileCameraClose(e)}
                                                                name="btn-cancel"
                                                            >
                                                                {"Okay"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {!onCameraError && !onCameraPermissionDenied && (
                                                    <div className="camera-popup-visible">
                                                        <div className="userprofile-header">
                                                            <i onClick={(e) => handleProfileCameraClose(e)}>
                                                                <ClosePopupHoc  viewBox="0 0 24 24" />
                                                            </i>
                                                            {photoTaken ? (
                                                                <h5>{CROP_PHOTO}</h5>
                                                            ) : (
                                                                <h5>{TAKE_PHOTO}</h5>
                                                            )}
                                                        </div>
                                                        <div className="cameraview">
                                                        {photoTaken &&
                                                            <div id='CameraContainer'></div>
                                                        }
                                                            {!photoTaken && <WebChatCamera sendFile={setWebcamImageVcard} onCameraCheck={onCameraCheckVcard} />}
                                                        </div>
                                                        {photoTaken && (
                                                            <div className="popup-controls">
                                                                {!loaderIcon && (
                                                                    <i title="Re capture">
                                                                        {" "}
                                                                        <ResetHoc viewBox="0 0 39 39"
                                                                            onClick={(e) =>
                                                                                handleProfileCameraShow(e, "reset")
                                                                            }
                                                                        />
                                                                    </i>
                                                                )}
                                                                {!loaderIcon ? (
                                                                    <i
                                                                        title="Update Profile"
                                                                        onClick={(e) => handleCropImage()}
                                                                    >
                                                                        <TickHoc
                                                                        viewBox="0 0 39 39"/>
                                                                    </i>
                                                                ) : (
                                                                    <img src={loaderGIF} alt="loader" />
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {showProfilePhotoRemove && (
                                            <div className="removephoto-container">
                                                <div className="removephoto-popup">
                                                    <div className="removephoto-label">
                                                        <label>{REMOVE_YOUR_PROFILE_PHOTO}</label>
                                                    </div>
                                                    <div className="removephoto-noteinfo">
                                                        <button
                                                            type="button"
                                                            className="btn-cancel"
                                                            onClick={(e) => handleProfileRemovephotoClose(e)}
                                                            name="btn-cancel"
                                                        >
                                                            {CANCEL}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-removephoto"
                                                            onClick={(e) => removeProfileImage(e)}
                                                            name="btn-remove"
                                                        >
                                                            {REMOVE}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </OutsideClickHandler>
                                </div>
                                <WebChatFields />
                            </div>
                        </div>
                    </OutsideClickHandler>
                </div>
            )}
        </React.Fragment>
    );
};
export default WebChatVCard;
